const React = require('react')
const { useState } = require('react')
const { DropdownToggle, DropdownMenu, DropdownItem, UncontrolledDropdown } = require('reactstrap')
const PropTypes = require('prop-types')

require('@styles/components/common/dropdown.style.css')

const CustomDropdown = props => {
    const { listItems, currentItem, handleClick, disabled = false, className } = props
    const [dropdownOpen, setDropdownOpen] = useState(false)
    const toggle = () => setDropdownOpen(prevState => !prevState)

    return (
        <UncontrolledDropdown
            isOpen={dropdownOpen}
            toggle={toggle}
            disabled={disabled}
            className={`custom-dropdown ${className || ''}`}
        >
            <DropdownToggle caret nav className='custom-dropdown-btn'>
                {currentItem?.iconPath && <img src={currentItem.iconPath} width='20px' alt='' />}
                &nbsp;{currentItem?.title}
            </DropdownToggle>
            <DropdownMenu className='custom-dropdown-menu'>
                {listItems?.map((item, index) => {
                    if (item.type === 'divider') {
                        return <DropdownItem key={index} divider />
                    }
                    return (
                        <DropdownItem
                            key={index}
                            className='custom-dropdown-item'
                            value={item.value}
                            onClick={() => handleClick(item.value)}
                        >
                            {item.iconUrl && <img src={item.iconUrl} width='20px' alt='' />}
                            &nbsp;
                            {item.name}
                        </DropdownItem>
                    )
                })}
            </DropdownMenu>
        </UncontrolledDropdown>
    )
}

CustomDropdown.propTypes = {
    listItems: PropTypes.arrayOf(
        PropTypes.shape({
            type: PropTypes.string,
            value: PropTypes.string,
            name: PropTypes.string,
            iconUrl: PropTypes.string
        })
    ).isRequired,
    currentItem: PropTypes.shape({
        title: PropTypes.string,
        iconPath: PropTypes.string
    }).isRequired,
    handleClick: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    className: PropTypes.string
}

module.exports = { CustomDropdown }
